import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect, useState } from "react";
import { getAllEstimate, getAllParallelEstimate } from "../../actions/EstimateActions";
import Mobilemenu from "../../layouts/mobile-menu";
import Select from 'react-select';
import { styleSelect } from "../../constants/customStyles";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import { useNavigate } from "react-router-dom";

function InsuranceReport() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);

    useEffect(() => {
        dispatch(getAllInsuranceCompany(null, 9999, { status: 1 }));
    }, [])

    const [filter, setFilter] = useState('');

    const handleFilter = (event) => {
        setFilter({
            ...filter,
            [event.target.name]: event.target.value,
        })
    }

    const handleFilterContractorDropdown = (selectedOptions) => {
        if (selectedOptions) {
            setFilter({
                ...filter,
                'contractor_id': selectedOptions.map(option => option.insurance_company_id),
                'contractor_name': selectedOptions.map(option => option.name),
            })
        } else {
            setFilter({
                ...filter,
                'contractor_id': [],
                'contractor_name': [],
            })
        }
    }
    const handleFilterStatusDropdown = (option) => {
        if (option) {
            setFilter({
                ...filter,
                'value': option.value,
                'label': option.label,
            })
        } else {
            setFilter({
                ...filter,
                'value': [],
                'label': [],
            })
        }
    }

    const handleFilterLpoDropdown = (option) => {
        if (option) {
            setFilter({
                ...filter,
                'lpo_value': option.lpo_value,
                'lpo_label': option.lpo_label,
            })
        } else {
            setFilter({
                ...filter,
                'lpo_value': [],
                'lpo_label': [],
            })
        }
    }

    const handleClearFilter = () => {
        setFilter(null)
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterSearch();
        }
    }
    const filterSearch = () => {
        window.open(`/insurance-report-print?filter=${JSON.stringify(filter)}`, '_blank');
    }

    const statusOptions = [
        { value: '', label: 'Please Select' },
        { value: 'sent', label: 'Sent' },
        { value: 'draft', label: 'Draft' },
        { value: 'overdue', label: 'Overdue' },
        { value: 'paid', label: 'Paid' },
        { value: 'void', label: 'Void' },
        { value: 'unpaid', label: 'Unpaid' },
        { value: 'partially_paid', label: 'Partially Paid' },
        { value: 'viewed', label: 'Viewed' }
    ]

    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />

                    <span>
                        {/* <!-- BEGIN: Data List --> */}
                        <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">

                            <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                aria-controls="faq-accordion-collapse-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                Filters </button>
                        </div>
                        <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                            data-bs-parent="#faq-accordion-1">
                            <div class="grid columns-12 gap-6 mt-5">
                                <div class="intro-y g-col-12 g-col-lg-12">
                                    <div class="intro-y box p-5">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Date From</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.date_from} name="date_from"
                                                        class="form-control w-full" placeholder="Enter Date From." />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Date To</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.date_to} name="date_to"
                                                        class="form-control w-full" placeholder="Enter Date to." />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Invoice Date From</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.inv_date_from} name="inv_date_from"
                                                        class="form-control w-full" placeholder="Enter Date From." />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Invoice Date To</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.inv_date_to} name="inv_date_to"
                                                        class="form-control w-full" placeholder="Enter Date to." />
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-4 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Job Id</label>
                                                    <input
                                                        id="crud-form-1"
                                                        type="text"
                                                        onChange={handleFilter}
                                                        name="job_id"
                                                        class="form-control w-full"
                                                        placeholder="Search"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-4 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Claim #</label>
                                                    <input
                                                        id="crud-form-1"
                                                        type="text"
                                                        onChange={handleFilter}
                                                        name="claim_no"
                                                        class="form-control w-full"
                                                        placeholder="Search"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-4 mt-2">
                                                <div>
                                                    <label for="crud-form-2" class="form-label font-weight-bold">Insurance Company</label>
                                                    <Select
                                                        isMulti
                                                        onChange={handleFilterContractorDropdown}
                                                        value={filter?.contractor_id?.map((id, index) => ({
                                                            id: id,
                                                            name: filter?.contractor_name[index]
                                                        }))}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.insurance_company_id}
                                                        options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                        styles={styleSelect}
                                                        placeholder="Select Insurance Companies"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-4 mt-2">
                                                <div>
                                                    <label for="crud-form-2" class="form-label font-weight-bold">Status</label>
                                                    <Select
                                                        onChange={handleFilterStatusDropdown}
                                                        options={statusOptions}
                                                        styles={styleSelect}
                                                        placeholder="Select Status"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-md-4 mt-2">
                                                <label className="form-label font-weight-bold">LPO Is</label>

                                                <Select
                                                    onChange={handleFilterLpoDropdown}
                                                    value={
                                                        filter.lpo_value
                                                            ? { lpo_value: filter.lpo_value, lpo_label: filter.lpo_label }
                                                            : null
                                                    }
                                                    getOptionLabel={(option) => option.lpo_label}
                                                    getOptionValue={(option) => option.lpo_value}
                                                    options={[{ lpo_value: 1, lpo_label: "True" }, { lpo_value: 2, lpo_label: "False" }]}
                                                    styles={styleSelect}
                                                    placeholder="LPO Is"
                                                />
                                            </div>

                                        </div>
                                        <div class="text-end mt-5">
                                            <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                Search</button>
                                            <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </span>
                    {/* } */}
                </div >
            </div >
        </span >
    )
}
export default InsuranceReport;